<template>
  <div class="account-change-password">
    <form @submit.prevent="submit">
      <form-group
        id="password_old"
        v-model="form.password_old"
        :errors="errors.password_old"
        type="password"
        placeholder="Senha atual"
        label="Senha atual"
      />

      <form-group
        id="password"
        v-model="form.password"
        :errors="errors.password"
        type="password"
        placeholder="Digite nova senha"
        label="Nova senha"
      />

      <form-group
        id="confirm_password"
        v-model="confirm_password"
        type="password"
        placeholder="Digite nova senha"
        label="Confirmar senha"
      />

      <div class="d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-light px-4"
          :disabled="loading"
          :style="password"
        >
          <loading :show="loading">Salvar</loading>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  data() {
    return {
      loading: false,
      ...formFields(["password_old", "password"]),
      confirm_password: ""
    };
  },
  methods: {
    submit() {
      if (this.confirm_password != this.form.password) {
        this.$message.error("Nova senha e senha de confirmação diferentes");
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("user/updatePassword", this.form)
        .then(() => {
          this.$message.success("Senha alterada com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    password() {
      const passwordButton =
        this.$setup.theme === "dark"
          ? { background: "#FFF" }
          : { background: "#3e56ac", color: "#FFF" };
      return passwordButton;
    }
  }
};
</script>
